var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"新規FAQ項目追加","bread-crumbs":_vm.breadCrumbs}},[_c('faq-edit',{attrs:{"is-add-new":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }